import { memo } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Icon from '@mdi/react'
import { mdiCircle } from '@mdi/js'

import { ErrorText, ModuleTable, StatusWrapper } from './styles'
import theme from 'theme_'
import { commonMessages } from 'app/i18n/messages'
import SuccessModal from 'components/Modal/SuccessModal'
import { messages } from '../messages'
import { SmartHardware } from 'features/home/types'

interface StatusCardProps {
  modalOpen: boolean
  onClose: Function
  offlineModules: SmartHardware[]
  circuitNames: { [key: string]: string }
}

function DetailsModal({
  modalOpen,
  onClose,
  offlineModules,
  circuitNames,
}: StatusCardProps) {
  const { formatMessage } = useIntl()

  const isMobile = window.matchMedia(theme.devices.mobile).matches

  return (
    <SuccessModal
      title={formatMessage(messages.powerModules)}
      isOpen={modalOpen}
      confirmBtnTitle={formatMessage(commonMessages.ok)}
      onConfirm={() => onClose()}
    >
      {offlineModules.length > 0 && (
        <>
          <StatusWrapper>
            <Icon
              path={mdiCircle}
              size={0.5}
              color={
                offlineModules.length
                  ? theme.colors.error
                  : theme.colors.successGreen
              }
            />
            <ErrorText
              color={
                offlineModules.length
                  ? theme.colors.error
                  : theme.colors.duneWarmGrey
              }
            >
              {offlineModules.length > 1
                ? formatMessage(messages.modulesOffline, {
                    number: offlineModules.length,
                  })
                : formatMessage(messages.moduleOffline, {
                    number: offlineModules.length,
                  })}
            </ErrorText>
          </StatusWrapper>
          <ModuleTable>
            {isMobile ? (
              <>
                {offlineModules.map((module) => (
                  <tr key={module.hwUID}>
                    <td>
                      <div>
                        <strong>
                          {module.olaConfig.DevicesModelDescription}
                        </strong>
                      </div>
                      <div>{`${formatMessage(messages.circuitName)}: ${
                        circuitNames[module.hwUID]
                      }`}</div>
                      <div>
                        {`${formatMessage(messages.uid)}: ${module.hwUID}`}
                      </div>
                    </td>
                  </tr>
                ))}
              </>
            ) : (
              <>
                <tr>
                  <th>
                    <FormattedMessage {...messages.powerModule} />
                  </th>
                  <th>
                    <FormattedMessage {...messages.circuitName} />
                  </th>
                  <th>
                    <FormattedMessage {...messages.uid} />
                  </th>
                </tr>
                {offlineModules.map((module) => (
                  <tr key={module.hwUID}>
                    <td>
                      <strong>
                        {module.olaConfig.DevicesModelDescription}
                      </strong>
                    </td>
                    <td>{circuitNames[module.hwUID]}</td>
                    <td>{module.hwUID}</td>
                  </tr>
                ))}
              </>
            )}
          </ModuleTable>
        </>
      )}
    </SuccessModal>
  )
}

export default memo(DetailsModal)
